<div class="login-background min-h-screen flex flex-col justify-between items-center p-4">
    <div class="flex flex-grow w-full justify-center items-center">
        <router-outlet></router-outlet>
    </div>
    <img alt="Artesp Logo" height="50" ngSrc="./assets/images/artesp_logo_white.svg" priority width="244"/>
</div>
